import { render, staticRenderFns } from "./MarketingEmailFormContent.vue?vue&type=template&id=a56293b4&scoped=true"
import script from "./MarketingEmailFormContent.vue?vue&type=script&lang=js"
export * from "./MarketingEmailFormContent.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailFormContent.vue?vue&type=style&index=0&id=a56293b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56293b4",
  null
  
)

export default component.exports